import React from 'react';
import { Route, IndexRoute, IndexRedirect, Redirect } from 'react-router';

// NOTE: here we're making use of the `resolve.root` configuration
// option in webpack, which allows us to specify import paths as if
// they were from the root of the ~/src directory. This makes it
// very easy to navigate to files regardless of how deeply nested
// your current file is.
import AppContainer from 'containers/AppContainer';
import LoginContainer from 'containers/LoginContainer';
import MainContainer from 'containers/MainContainer';
import DocumentsListContainer from 'containers/DocumentsListContainer';
import DocumentContainer from 'containers/DocumentContainer';
import MultimidiaContainer from 'containers/MultimidiaContainer';
import FTPContainer from 'containers/FTPContainer';
import ChangePasswordContainer from 'containers/ChangePasswordContainer';
import RecoverPasswordContainer from 'containers/RecoverPasswordContainer';
import ExplorerContainer from 'containers/ExplorerContainer';
import WelcomeContainer from 'containers/WelcomeContainer';
import ManualContainer from 'containers/ManualContainer';
import CreateNewUserContainer from 'containers/CreateNewUserContainer';
import GerenciarUsuariosContainer from 'containers/GerenciarUsuariosContainer';
import GerenciarMaplayersContainer from 'containers/GerenciarMaplayersContainer';
import AccessLogContainer from 'containers/AccessLogContainer';

import Dashboard from 'components/Home/Dashboard';
import NotFound from 'components/Common/NotFound';

function fullPermissionUserRoutes(store) {
	const isGisOnly = store.getState().login.isGisOnly;
	if (isGisOnly) {
		return (
			<Route path='admin'>
				<Redirect path='*' to="documents/explorer" />
			</Route>
		);
	}
	
	return (
		<Route path="admin" component={MainContainer}>
			<Route path='create_new_user' component={CreateNewUserContainer} />
			<Route path='change_user' component={CreateNewUserContainer} />
			<Route path='gerenciar_usuarios' component={GerenciarUsuariosContainer} />
			<Route path='gerenciar_maplayers' component={GerenciarMaplayersContainer} />
			<Route path='access_log' component={AccessLogContainer} />
			<Route path='documents/view' component={DocumentsListContainer} />
			<Route path="documents/view/:id" component={DocumentContainer} />
			<Route path="multimidia(/:project)" component={MultimidiaContainer} />
			<Route path='documents/create(/:projeto)(/:fileIDs)' component={DocumentContainer} />
			<Route path='documents/ftp' component={FTPContainer} />
			<Route path='welcome' component={WelcomeContainer} />
			<Route path='manual' component={ManualContainer} />
			<Redirect from="documents" to="documents/view" />
		</Route>
	);
}
// eslint-disable-next-line react/no-multi-comp
export default (store) => (
	<Route path='/' component={AppContainer}>
		<IndexRedirect to="/admin/welcome" />
		<Route path="admin" component={MainContainer}>
			<IndexRoute component={Dashboard} />
			<Route path='change_password' component={ChangePasswordContainer} />
			<Route path='documents/explorer' component={ExplorerContainer} />
		</Route>
		
		{fullPermissionUserRoutes(store)}

		<Route path='login' component={LoginContainer} />
		<Route path='recover_password' component={RecoverPasswordContainer} />
		<Route path='new_password' component={ChangePasswordContainer} />

		{/* URL don't match any of above, render not found component */}
		<Route path='*' component={NotFound} />
	</Route>
);


// WEBPACK FOOTER //
// ./src/routes/index.js